import {serializable, alias, primitive, list, object} from 'serializr';

export class BoardModel{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('acronym', primitive()))
    acronym?: string;
    @serializable(alias('display_picture_url', primitive()))
    displayPictureUrl?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
}
export class BoardMetaModel {
    @serializable(alias('id', primitive()))
    value?: string;
    @serializable(alias('acronym', primitive()))
    label?: string;
}

export class BoardClassRoom{
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('name', primitive()))
    name?: string;
    @serializable(alias('amount_paise', primitive()))
    amountPaise?: string;
    @serializable(alias('amount_rupees', primitive()))
    amountRupees?: string;
    @serializable(alias('amount', primitive()))
    amount?: number;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('class_room_subject_count', primitive()))
    subjectCount?: number;
}
export class Board {
    @serializable(alias("id", primitive()))
    id?: number;
  
    @serializable(alias("name", primitive()))
    name?: string;
  
    @serializable(alias("acronym", primitive()))
    acronym?: string;
  
    @serializable(alias("class_rooms", list(object(BoardClassRoom))))
    classRooms?: BoardClassRoom[];
  
    @serializable(alias("display_picture_url", primitive()))
    displayPictureUrl?: string;
  }